import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, Images, Tag, Users, Settings, LogOut, ExternalLink, Menu } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Sheet, SheetContent, SheetTitle } from "../ui/sheet";

const ITEMS = [
  { to: "/admin", label: "Dashboard", Icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/produtos", label: "Produtos", Icon: Package, id: "products" },
  { to: "/admin/banners", label: "Banners", Icon: Images, id: "banners" },
  { to: "/admin/promocoes", label: "Promoções", Icon: Tag, id: "promotions" },
  { to: "/admin/clientes", label: "Clientes", Icon: Users, id: "customers" },
  { to: "/admin/configuracoes", label: "Configurações", Icon: Settings, id: "settings" },
];

function Nav({ onNavigate }) {
  const { user, logout } = useAuth();
  return (
    <div className="flex h-full flex-col">
      <div className="px-6 py-8">
        <p className="gold-text font-serif text-2xl font-semibold tracking-[0.3em]">EMAIA</p>
        <p className="text-[10px] uppercase tracking-[0.4em] text-[#A1A1AA]">Painel administrativo</p>
      </div>
      <nav className="flex-1 space-y-1 px-3">
        {ITEMS.map(({ to, label, Icon, end, id }) => (
          <NavLink key={to} to={to} end={end} onClick={onNavigate} data-testid={`admin-nav-${id}`}
            className={({ isActive }) => `flex items-center gap-3 rounded-xl px-4 py-3 text-sm transition-colors ${isActive ? "bg-[#D4AF37]/12 text-[#F3E5AB]" : "text-[#A1A1AA] hover:bg-white/5 hover:text-[#FAF6F0]"}`}>
            <Icon className="h-4 w-4" />{label}
          </NavLink>
        ))}
      </nav>
      <div className="space-y-1 border-t border-white/5 p-3">
        <Link to="/" target="_blank" className="flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-[#A1A1AA] hover:text-[#FAF6F0]" data-testid="admin-view-site"><ExternalLink className="h-4 w-4" />Ver site</Link>
        <button onClick={logout} className="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm text-[#A1A1AA] hover:text-red-400" data-testid="admin-logout-button"><LogOut className="h-4 w-4" />Sair</button>
        <p className="truncate px-4 pt-2 text-[11px] text-[#A1A1AA]/60">{user?.email}</p>
      </div>
    </div>
  );
}

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#0B0B0C] text-[#FAF6F0]" data-testid="admin-layout">
      <aside className="fixed inset-y-0 left-0 hidden w-64 border-r border-[#D4AF37]/12 bg-[#08080A] lg:block"><Nav /></aside>
      <div className="sticky top-0 z-30 flex items-center gap-4 border-b border-[#D4AF37]/12 bg-[#08080A]/90 px-5 py-4 backdrop-blur lg:hidden">
        <button onClick={() => setOpen(true)} aria-label="Menu" data-testid="admin-mobile-menu"><Menu className="h-6 w-6 text-[#F3E5AB]" /></button>
        <p className="gold-text font-serif text-xl tracking-[0.3em]">EMAIA</p>
      </div>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-72 border-r border-[#D4AF37]/20 bg-[#08080A] p-0">
          <SheetTitle className="sr-only">Menu administrativo</SheetTitle>
          <Nav onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
      <main className="px-5 py-8 lg:ml-64 lg:px-10 lg:py-10"><Outlet /></main>
    </div>
  );
}
